__turbopack_context__.v({
  "border-card": "BorderCard-module-scss-module__fdgoAa__border-card",
  "minimal": "BorderCard-module-scss-module__fdgoAa__minimal",
});
